import React from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { useDeleteBooking } from "@api/v1/hooks/useBookings";
import { GET_REALIZED_GAINS } from "@api/cacheKeys";
import { ConfirmDeleteDialog } from "@components";

export interface Props {
  bookingId: number;
  dialogOpen: boolean;
  onClose: () => void;
}

export const BookingsTableDeleteAction = ({
  dialogOpen,
  bookingId,
  onClose,
}: Props) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const {
    mutate,
    isPending,
    isError,
    error,
    reset: mutationReset,
  } = useDeleteBooking({
    onSuccess: () => {
      handleCloseDialog();
      queryClient.refetchQueries({
        queryKey: [GET_REALIZED_GAINS],
      });
    },
    retry: false,
  });

  const handleDeleteClick = () => {
    mutate(bookingId);
  };
  const handleCloseDialog = () => {
    onClose();
    mutationReset();
  };

  return (
    <ConfirmDeleteDialog
      isOpen={dialogOpen}
      onClose={handleCloseDialog}
      onDelete={handleDeleteClick}
      isDeleteRequestLoading={isPending}
      text={t("investment.protocolTable.deleteDialog.questionMessage")}
      title={t("investment.protocolTable.deleteDialog.title")}
      confirmButtonText={t(
        "investment.protocolTable.deleteDialog.actions.delete"
      )}
      cancelButtonText={t(
        "investment.protocolTable.deleteDialog.actions.close"
      )}
      errorMessage={isError ? error?.response?.data?.message : undefined}
      testId="delete-confirmation-dialog"
    />
  );
};
